import SectionHeader from "@/components/feature/SectionHeader";
import { reviews } from "@/mocks/reviews";

export default function Reviews() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="container-site">
        <SectionHeader
          align="center"
          eyebrow="读者口碑"
          title="幻想同好们怎么说"
          subtitle="每一份喜爱与认可，都是我们坚持用心选漫的动力。"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r) => (
            <figure key={r.name} className="card flex flex-col p-5">
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={i < r.rating ? "ri-star-fill text-sm" : "ri-star-line text-sm text-foreground-300"} />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{r.content}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-100 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-700">
                  {r.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}